import cx from 'classnames'
import React from 'react'
import { FullscreenDialog } from './FullscreenDialog'
import { H2 } from '../typography'
import { dialogSizeClasses } from '../GenericDialog/GenericDialog'

function GenericFullscreenDialogHeader({
  title,
  subtitle
}: {
  title: string
  subtitle?: string
  icon?: React.ReactNode
  showCloseButton?: boolean
  closeButtonText?: string
  onClose: () => void
}) {
  return (
    <header className="fullscreen-dialog-header">
      <div className="fullscreen-dialog-header-content">
        <div className="fullscreen-dialog-header-flex">
          <div>
            <H2>{title}</H2>
            {subtitle && <p className="fullscreen-dialog-subtitle">{subtitle}</p>}
          </div>
        </div>
      </div>
    </header>
  )
}

function GenericFullscreenDialogFooter({ actions }: { actions: React.ReactNode }) {
  return (
    <footer className="fullscreen-dialog-footer">
      <div className="fullscreen-dialog-footer-content">
        <div className="fullscreen-dialog-footer-actions">{actions}</div>
      </div>
    </footer>
  )
}

export function GenericFullscreenDialog({
  isOpen,
  close,
  children,
  onAfterLeave,
  title,
  subtitle,
  containerSize = '4xl',
  icon,
  preventCloseOnOutsideClick = false,
  showCloseButton = true,
  closeButtonText = 'Close',
  className,
  contentClassName,
  actions
}: {
  isOpen: boolean
  close: () => void
  children: React.ReactNode
  onAfterLeave?: () => void
  title?: string
  subtitle?: string
  containerSize?: 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl'
  icon?: React.ReactNode
  preventCloseOnOutsideClick?: boolean
  showCloseButton?: boolean
  closeButtonText?: string
  className?: string
  contentClassName?: string
  actions?: React.ReactNode
}) {
  return (
    <FullscreenDialog
      isOpen={isOpen}
      close={close}
      onAfterLeave={onAfterLeave}
      preventCloseOnOutsideClick={preventCloseOnOutsideClick}
      className={className}
    >
      <div className="fullscreen-dialog-content-wrapper">
        {title && (
          <GenericFullscreenDialogHeader
            title={title}
            subtitle={subtitle}
            icon={icon}
            showCloseButton={showCloseButton}
            closeButtonText={closeButtonText}
            onClose={close}
          />
        )}
        <div className="fullscreen-dialog-body">
          <div className={cx('fullscreen-dialog-content', contentClassName)}>
            <div
              className={cx(
                'fullscreen-dialog-content-inner',
                containerSize ? dialogSizeClasses[containerSize] : ''
              )}
            >
              {children}
            </div>
          </div>
        </div>
        {actions && <GenericFullscreenDialogFooter actions={actions} />}
      </div>
    </FullscreenDialog>
  )
}
